import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid, Modal, Typography, Stack, Select, MenuItem } from "@mui/material";

import { Button, Alert } from "../../../common/styled";
import ModalBox from "../../../../common/ModalBox";

import useLLMConfig from "../../../../../hooks/user/useLLMConfig";

const MatchingStrategies = ['exact', 'case_insensitive', 'fuzzy', 'combined_exact_fuzzy'];

function DeanonymizeModal({ open, handleClose, zoneUid }) {
  const { llmOutputScanners, configLLMSettingOutputScanners } = useLLMConfig();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        matching_strategy: llmOutputScanners ? llmOutputScanners?.deanonymize?.matching_strategy : "",
      }}
      validationSchema={Yup.object().shape({
        matching_strategy: Yup.string().nullable().required("Matching strategy is required"),
      })}
      onSubmit={async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        try {
          values.submit = undefined;
          await configLLMSettingOutputScanners(zoneUid, "deanonymize", values);
          handleClose();
          resetForm();
        } catch (error) {
          const message = error.message || "Something went wrong";
          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting, touched, values }) => (
        <React.Fragment>
          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleClose();
              }
            }}
          >
            <ModalBox sx={{ width: "60vw" }} title="Edit Deanonymize Scanner" handleClose={handleClose}>
              <form noValidate onSubmit={handleSubmit}>
                <Grid container p={4} spacing={3}>
                  <Grid item xs={12}>
                    {errors.submit && (
                      <Alert mt={2} mb={3} variant="outlined" severity="error">
                        {errors.submit}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Matching Strategy</Typography>
                      <Select
                        fullWidth
                        name="matching_strategy"
                        value={values.matching_strategy}
                        error={Boolean(touched.matching_strategy && errors.matching_strategy)}
                        helperText={touched.matching_strategy && errors.matching_strategy}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      >
                        {MatchingStrategies.map((type) => (
                          <MenuItem value={type} key={`matching_strategy_${type}`}>
                            {type}
                          </MenuItem>
                        ))}
                      </Select>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} textAlign={"right"} pt={4}>
                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
                      <Button variant="outlined" color="secondary" size="modal" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button type="submit" variant="contained" color="success" size="modal" disabled={isSubmitting}>
                        Save
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </form>
            </ModalBox>
          </Modal>
        </React.Fragment>
      )}
    </Formik>
  );
}

export default DeanonymizeModal;
